<div class="flex flex-col items-center p-8 gap-8 w-full max-w-[1440px] bg-[#FDFDFD]">
  <!-- Service Status -->
  <div class="flex flex-col justify-center items-start p-6 gap-4 w-full max-w-[560px]">
    <div class="flex flex-col items-start gap-1 w-full">
      <h1 class="text-2xl font-extrabold text-[#003746] leading-[120%] tracking-tight">Generado exitosamente</h1>
      <p class="text-sm text-[#303638] leading-[150%]">Tu expediente ha sido generado. El formato de autorización para el servicio de Segunda opinión ha sido enviado al método de contacto preferido.<br>También puedes descargarlo aquí:</p>
    </div>
    
    <!-- Botones de contacto -->
    <div class="contact-buttons">
      <button class="contact-btn" (click)="makeCall()">
        <mat-icon>phone</mat-icon>
        <span>Llamar</span>
      </button>
      <button class="contact-btn" (click)="openWhatsApp()">
        <img src="assets/images/icons/whats.png" alt="WhatsApp">
        <span>WhatsApp</span>
      </button>
    </div>
    
    <div class="flex justify-between items-center p-2 gap-1 sm:gap-2 w-full bg-[rgba(210,228,255,0.16)] border border-[#D9E7F3] rounded-xl overflow-hidden">
      <div class="relative w-20 h-12 sm:w-[145px] sm:h-[71px] flex-shrink-0">
        <div class="w-full h-full bg-[#E8F4FD] rounded-lg relative">
          <div class="absolute top-1 left-1 sm:top-[19px] sm:left-[6px] w-8 h-4 sm:w-[54px] sm:h-[21px] bg-white flex items-center justify-center text-[8px] sm:text-[11px] font-light text-[#5890B5] px-0.5 sm:px-1">
            <span class="hidden sm:inline">SEGUNDA OPINIÓN</span>
            <span class="sm:hidden">PDF</span>
          </div>
          <div class="absolute bottom-1 left-1 sm:bottom-[11px] sm:left-[5px] w-12 h-2 sm:w-[76px] sm:h-3 bg-[#F6F7F2] flex items-center justify-center text-[6px] sm:text-[8px] text-black px-0.5 sm:px-1">
            <span class="hidden sm:inline">segundaopinion.pdf</span>
            <span class="sm:hidden">archivo.pdf</span>
          </div>
        </div>
      </div>
      <button class="flex items-center justify-center px-2 sm:px-4 py-1.5 sm:py-2 gap-1 bg-[#052631] hover:bg-[#041f28] rounded-full text-white transition-colors flex-shrink-0 min-w-0">
        <mat-icon class="text-xs sm:text-sm">download</mat-icon>
        <span class="text-xs sm:text-sm font-medium whitespace-nowrap">Descargar</span>
      </button>
    </div>
  </div>

  <!-- Service Details -->
  <div class="flex flex-col justify-center items-start p-6 gap-4 w-full max-w-[560px]">
    <div class="flex flex-col items-start gap-1 w-full">
      <h2 class="text-lg font-extrabold text-[#003746] leading-[120%] tracking-tight">Detalles del servicio</h2>
      <p class="text-sm text-[#303638] leading-[150%]">Encuentra todos los datos importantes sobre esta solicitud.</p>
    </div>

    <div class="flex flex-col items-center p-2 gap-2 w-full bg-[rgba(210,228,255,0.16)] border border-[#D9E7F3] rounded-2xl">
      <button (click)="toggleDetails()" class="flex items-center justify-center py-2 gap-2 w-full border-b border-[#9FC7E7] hover:bg-[rgba(210,228,255,0.3)] transition-colors cursor-pointer">
        <mat-icon class="w-4 h-4 text-[#166DB3]">medical_services</mat-icon>
        <span class="flex-1 text-base font-extrabold text-[#003746] leading-[120%] tracking-tight">Segunda opinión</span>
        <mat-icon class="w-4 h-4 text-[#382100] transition-transform" [class.rotate-180]="!isDetailsExpanded">expand_less</mat-icon>
      </button>

      <div *ngIf="isDetailsExpanded" class="w-full">
        <div class="flex items-start py-2 gap-2 w-full border-b border-[#9FC7E7]">
          <div class="flex flex-col justify-center items-start flex-1">
            <h4 class="text-sm font-extrabold text-[#003746] leading-[120%] tracking-tight">Paciente</h4>
            <p class="text-sm text-[#303638] leading-[150%]">Mauricio Torres</p>
          </div>
        </div>

        <div class="flex items-start py-2 gap-2 w-full border-b border-[#9FC7E7]">
          <div class="flex flex-col justify-center items-start flex-1">
            <h4 class="text-sm font-extrabold text-[#003746] leading-[120%] tracking-tight">Unidad médica</h4>
            <p class="text-sm text-[#303638] leading-[150%]">Especialidades médicas Sta María</p>
          </div>
        </div>

        <div class="flex items-start py-2 gap-2 w-full border-b border-[#9FC7E7]">
          <div class="flex flex-col justify-center items-start flex-1">
            <h4 class="text-sm font-extrabold text-[#003746] leading-[120%] tracking-tight">Fecha de solicitud</h4>
            <p class="text-sm text-[#303638] leading-[150%]">30/04/2025</p>
          </div>
          <div class="flex flex-col justify-center items-start flex-1">
            <h4 class="text-sm font-extrabold text-[#003746] leading-[120%] tracking-tight">Hora de solicitud</h4>
            <p class="text-sm text-[#303638] leading-[150%]">14:32</p>
          </div>
        </div>

        <div class="flex items-start py-2 gap-2 w-full">
          <div class="flex flex-col justify-center items-start flex-1">
            <h4 class="text-sm font-extrabold text-[#003746] leading-[120%] tracking-tight">Precio</h4>
            <p class="text-sm text-[#303638] leading-[150%]">Gratis</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>